export default __webpack_public_path__ + "static/media/157e60a0371b119120faeab9fed90ba8.png";